import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-55c83611")
const _hoisted_1 = { id: "interface" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "_header" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "_headerText" }, " Home ")
], -1)
const _hoisted_3 = { class: "_main" }
const _hoisted_4 = {
  key: 0,
  class: /*#__PURE__*/_normalizeClass({
        list:true,
        grid:true
      })
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "_gapper" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "_gapper" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "_gapper" }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "_gapper" }, null, -1)
const _hoisted_9 = {
  key: 1,
  class: "_loadPrompt"
}
const _hoisted_10 = {
  key: 2,
  class: "_footer _card"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("h4", null, "Advisory", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("p", null, " Game purchase states are managed through login states. Switching between accounts will not carry game purchases over. Our games are created in English. ", -1)
const _hoisted_13 = [
  _hoisted_11,
  _hoisted_12
]
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HistoryPopup = _resolveComponent("HistoryPopup")!
  const _component_GamePreview = _resolveComponent("GamePreview")!
  const _component_LoadSpinner = _resolveComponent("LoadSpinner")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_HistoryPopup),
    _createElementVNode("div", _hoisted_3, [
      (_ctx.games.length || _ctx.store.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_component_GamePreview, {
              tutorial: true,
              game: _ctx.tutorial,
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openGame(_ctx.tutorial)))
            }, null, 8, ["game"]),
            _hoisted_5,
            _createVNode(_component_GamePreview, {
              join: true,
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push({path:'/app/join'})))
            }),
            _hoisted_6,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.games, (game) => {
              return (_openBlock(), _createElementBlock(_Fragment, {
                key: game.id
              }, [
                _createVNode(_component_GamePreview, {
                  game: game,
                  onClick: ($event: any) => (_ctx.openGame(game))
                }, null, 8, ["game", "onClick"]),
                _hoisted_7
              ], 64))
            }), 128)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.store, (game) => {
              return (_openBlock(), _createElementBlock(_Fragment, {
                key: game.id
              }, [
                _createVNode(_component_GamePreview, {
                  game: game,
                  onClick: ($event: any) => (_ctx.openGame(game))
                }, null, 8, ["game", "onClick"]),
                _hoisted_8
              ], 64))
            }), 128))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createVNode(_component_LoadSpinner, { text: "Loading games" })
          ])),
      (_ctx.games.length || _ctx.store.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, _hoisted_13))
        : _createCommentVNode("", true)
    ])
  ]))
}